/**
 * Server-side Logger using Pino
 * For use in API routes, server components, and server actions
 */
import pino from 'pino';

const logLevel = process.env.LOG_LEVEL || process.env.NEXT_PUBLIC_LOG_LEVEL || 'info';

// Create the base logger
export const logger = pino({
  level: logLevel,
  browser: {
    asObject: true,
  },
  formatters: {
    level: (label) => {
      return { level: label.toUpperCase() };
    },
  },
  timestamp: pino.stdTimeFunctions.isoTime,
});

/**
 * Create a child logger with additional context
 */
export function createLogger(name: string, context?: Record<string, any>) {
  return logger.child({ name, ...context });
}

/**
 * Common loggers for different parts of the application
 */
export const loggers = {
  api: createLogger('api'),
  theme: createLogger('theme'),
  config: createLogger('config'),
  auth: createLogger('auth'),
  database: createLogger('database'),
  business: createLogger('business'),
};
